import { ApolloClient, gql } from "@apollo/client";
import _ from "lodash";
import {
  CreateCustomerOrderInput,
  CreateCustomerOrderPositionInput,
  CustomerOrder,
  CustomerOrderPosition,
} from "../api/schema";

const CreateCustomerOrderMutation = gql`
  mutation CreateCustomerOrder($values: CreateCustomerOrderInput!) {
    createCustomerOrder(values: $values) {
      id
    }
  }
`;

const CreateCustomerOrderPositionMutation = gql`
  mutation CreateCustomerOrderPosition(
    $values: CreateCustomerOrderPositionInput!
  ) {
    createCustomerOrderPosition(values: $values) {
      id
    }
  }
`;

const Create = (
  client: ApolloClient<any>,
  customer_order: CreateCustomerOrderInput
) =>
  client.mutate<CustomerOrder, { values: CreateCustomerOrderInput }>({
    mutation: CreateCustomerOrderMutation,
    variables: { values: customer_order },
  });

const CreatePosition = (
  client: ApolloClient<any>,
  customer_order_id: number,
  position: CreateCustomerOrderPositionInput
) =>
  client.mutate<
    CustomerOrderPosition,
    { values: CreateCustomerOrderPositionInput }
  >({
    mutation: CreateCustomerOrderPositionMutation,
    variables: {
      values: _.merge(position, { customer_order_id }),
    },
  });

export const CustomerOrderAPI = () => ({
  Create,
  CreatePosition,
});
